import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../services/api";
import {BaseBackEND} from "../services/auth"
import {Helmet} from 'react-helmet'


import HeaderUser from "./content/header";
import Footer from "../pages/content/footer"
import IMG from "../assets/img/banners/cursos/490.jpg"
import Whatsapp from "../assets/img/icon/whatsapp.png"


class FeaturesIndex extends Component {



  constructor() {
    super();

    this.state = { 
      curso: [],
      matrizcurricular:[],
      configuracao:[]

    }
      
  }


 
  async componentDidMount() {

    
   
    const response1 = await api.post("/curso/id", { idcurso:this.props.match.params.cursoid });
    const response2 =await api.post("/disciplinas/curso", { idcurso:this.props.match.params.cursoid });
    const response3= await api.post("/configuracao/show");

    this.setState({ 
      curso: response1.data,
      matrizcurricular:response2.data,
      configuracao:response3.data
    })
    document.title = this.state.curso.nome;

  }


  

  shouldComponentUpdate(nextProps, nextState){


    if(nextState.idcurso!==this.state.idcurso){
      localStorage.setItem("idcurso", nextState.idcurso);

      window.location.href ="/user/inscreva";
    }


    

    return true;
  }


  render() {
    const descontocurso ={
      'font-size':'12px'
    }

    let style_doubts={
      'font-family': "'Roboto Slab', serif "
    }
    return (
      <React.Fragment>
        
        <HeaderUser />
       
        <div class="container">

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">Faculdade Olga Mettig</a></li>
                {
                  this.state.curso.idcategoria &&
                  this.state.curso.idcategoria!=16 && 
                  <li class="breadcrumb-item"><a href="/pos-graduacao">Pós-Graduação</a></li>
                }
                {
                  this.state.curso.idcategoria==16 && 
                  <li class="breadcrumb-item"><a href="/pos-graduacao">Curso Curta Duração                  </a></li>
                }
                <li class="breadcrumb-item active">{this.state.curso.nome}</li>
            </ol>
        </nav>




  <div class="row">
    <div class="col-sm imgcursoshow">
      <img src={BaseBackEND()+this.state.curso.banner} />

{/*Descrição Curos */}


    <div class="row ">
            <div class="col mb-3 mb-md-0">
                <div class="card objective">
                <div class="card-body">
                    <h5 class="card-title">Objetivo </h5>
                    <p class="card-text">

                    {this.state.curso.objetivo}

                    </p>
                </div>



                <div class="card-body">
                    <h5 class="card-title">Público Alvo</h5>
                    <p class="card-text">
                    {this.state.curso.mercadotrabalho}

                    </p>
                </div>





                {/* Matriz Curricular */}
                

                <div class="card-body">
                    <h5 class="card-title">Matriz Curricular </h5>

                    <a class="btn btn-info" data-toggle="modal" data-target="#basicExampleModal" >Clique aqui para acessar</a>
                </div>

                <div class="modal fade" id="basicExampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Matriz Curricular</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
            {/* Tables */}

    <table id="dtBasicExample" class="table" cellspacing="0" width="100%">
    <thead class="blue white-text">
    <tr>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">Duração

      </th>
     
    </tr>
  </thead>
  <tbody>
  {this.state.matrizcurricular.map(el => (
    <tr>
    <td>{el.nome}</td>
    <td>{el.duracaohoras} horas</td>
   
  </tr>
  ))}
    

  </tbody>

</table>
<h6>Carga Horária: {this.state.curso.duracaohora} horas
</h6>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>






















                </div>
            </div>
    </div>





{/*Descrição Curos */}


      
    </div>
















      {/* Segunda Coluna */}
    <div class="col-sm-4 ">
    
      
      <div class="card carddetailscourse" >
            <a onClick={e => this.setState({ idcurso: this.props.match.params.cursoid })} class="btn btn-success px-3"><i class="far fa-thumbs-up" aria-hidden="true"></i> Inscreva-se</a>

                <div class="card-body">
                    <h7 class="card-title">{this.state.curso.nome}</h7>
                    {
                      this.state.curso.idcategoria &&
                      this.state.curso.idcategoria!=16 &&
                      <p class="card-text">Pós-Graduação</p>
                    }
                    {
                      this.state.curso.idcategoria==16 &&
                      <p class="card-text">Curso Curta Duração</p>
                    }
                </div>
                    {
                      this.state.curso.idcategoria &&
                      this.state.curso.idcategoria!=16 &&
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">Carga Horária: {this.state.curso.duracaohora} horas</li>
                        <li class="list-group-item">1º Mensalidade: R${this.state.curso.precoinscricao}</li>
                        <li class="list-group-item">Mensalidade: {this.state.curso.duracaosemestre}x R${this.state.curso.preco}* </li>
                        <li class="list-group-item">Duração: {this.state.curso.duracaosemestre} meses</li>
                        <li class="list-group-item"><center><i style={descontocurso}>*Valor já com desconto <br></br><b>Bolsa de 50%</b> durante todo o curso.</i></center></li>
                      
                      </ul>
                    }
                    {
                      this.state.curso.idcategoria==16 &&
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">Carga Horária: {this.state.curso.duracaohora} horas</li>
                        <li class="list-group-item">Valor: R${this.state.curso.preco} </li>
                        <li class="list-group-item">Duração: {this.state.curso.duracaosemestre} {this.state.curso.duracaosemestre>1?"dias":"dia"}</li>
                        <li class="list-group-item"><center><i style={descontocurso}>
                          <small>*Consulte valor da parcela no pagseguro.</small>
                           <br></br>Parcele em até 12x..</i></center></li>

                      </ul>
                    }
                
                <a href={"http://api.whatsapp.com/send?phone=55"+this.state.configuracao.whatsapp+"&text="+this.state.configuracao.whatsapptext} class="btn btn-primary" style={style_doubts}>      
                  Tirar Dúvidas
                  <img src={Whatsapp} width="25" class="ml-2 mb-2 ico-whatsapp"/>

                </a> 
                



                <ul class="list-group list-group-flush">
                {/*<li class="list-group-item"><center>Telefone: <b>71 4042-3039</b></center></li>*/}
                </ul>
                
        </div>











    </div>
      {/* Segunda Coluna */}

  </div> {/* Row Linha */}

  

<br></br><br></br><br></br><br></br>

        </div> {/* Fim Container */}


        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(FeaturesIndex);


// WEBPACK FOOTER //
// ./src/pages/showcurso.js